export const GROUPS_WIDGET_LAYOUT_GROUPS_LIST = 'groups-list';
export const GROUP_LIST_ITEM = 'group-list-item';
export const GROUP_LIST_ITEM_TITLE = 'group-list-item-tile';
